/**
 * SegmentedControl — molecule (CES standard)
 * Segmented toggle in the client portal's style: white group with orange
 * active segment. Used for the Modify|Upload JSON editor mode.
 */

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
  testId?: string;
}

export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
}: {
  options: SegmentedOption<T>[];
  value: T;
  onChange: (next: T) => void;
  ariaLabel: string;
}) {
  return (
    <div
      className="inline-flex rounded border border-gray-300 bg-white overflow-hidden"
      role="group"
      aria-label={ariaLabel}
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`px-5 py-2 text-sm font-semibold transition-colors cursor-pointer ${
            option.value === value
              ? 'bg-orange-500 text-white'
              : 'text-gray-600 hover:bg-gray-100'
          }`}
          aria-pressed={option.value === value}
          data-testid={option.testId}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
